import ApiService from "@/common/api.service";

const PATH = "stock/receipts";

export const GET_STOCK_RECEIPTS = "getStockReceipts";
export const GET_STOCK_RECEIPT = "getStockReceipt";
export const CREATE_STOCK_RECEIPT = "createStockReceipt";
export const UPDATE_STOCK_RECEIPT = "updateStockReceipt";
export const FINALIZE_STOCK_RECEIPT = "finalizeStockReceipt";
export const CANCEL_STOCK_RECEIPT = "cancelStockReceipt";
export const DISCARD_STOCK_RECEIPT = "discardStockReceipt";
export const GET_STOCK_RECEIPT_DRAFT_FROM_PO = "getStockReceiptDraftFromPurchaseOrder";
export const GET_STOCK_RECEIPT_DRAFT_FROM_TO = "getStockReceiptDraftFromTransportOrder";
export const REVERSE_STOCK_RECEIPT = "reverseStockReceipt";
export const CONVERT_STOCK_RECEIPT_TO_PHYSICAL = "convertStockReceiptToPhysical";
export const GET_STOCK_DEAL_OPTIONS = "getStockDealOptions";
export const GET_STOCK_ACTION_TYPE_OPTIONS = "getStockActionTypeOptions";
export const GET_STOCK_EXTRA_COST_TYPE_OPTIONS = "getStockExtraCostTypeOptions";
export const GET_STOCK_EXTRA_COST_ALLOCATION_METHOD_OPTIONS =
  "getStockExtraCostAllocationMethodOptions";
export const UPLOAD_STOCK_RECEIPT_FILES = "uploadStockReceiptFiles";
export const DELETE_STOCK_RECEIPT_FILE = "deleteStockReceiptFile";
export const DOWNLOAD_STOCK_RECEIPT_FILE = "downloadStockReceiptFile";
export const REGENERATE_STOCK_RECEIPT_DOCUMENT = "regenerateStockReceiptDocument";
export const IMPORT_STOCK_RECEIPT_TRANSPORT_COST = "importStockReceiptTransportCost";
export const GET_STOCK_ACTION_STATUSES = "getStockActionStatuses";

const actions = {
  [GET_STOCK_RECEIPTS](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.query(PATH, {
        ...(params || {}),
        ...context.rootGetters.stockContextFilterParams,
      })
        .then(({ data }) => resolve(data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [GET_STOCK_RECEIPT](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.get(PATH, id)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [CREATE_STOCK_RECEIPT](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.post(PATH, params)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [UPDATE_STOCK_RECEIPT](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.update(PATH, payload.id, payload.params)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [FINALIZE_STOCK_RECEIPT](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${id}/finalize`)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [CANCEL_STOCK_RECEIPT](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${id}/cancel`)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [DISCARD_STOCK_RECEIPT](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${id}/discard`)
        .then(() => resolve(true))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [GET_STOCK_RECEIPT_DRAFT_FROM_PO](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.query(`stock/purchase-orders/${payload.id}/receipt-draft`, payload.params || {})
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [GET_STOCK_RECEIPT_DRAFT_FROM_TO](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.query(`stock/transport-orders/${payload.id}/receipt-draft`, payload.params || {})
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [REVERSE_STOCK_RECEIPT](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${id}/reverse`)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [CONVERT_STOCK_RECEIPT_TO_PHYSICAL](context, payload) {
    const id = typeof payload === "object" ? payload.id : payload;
    const params = typeof payload === "object" ? payload.params || {} : {};

    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${id}/convert-to-physical`, params)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [GET_STOCK_DEAL_OPTIONS](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.query("stock/deals/options", params)
        .then(({ data }) => resolve(data.data || data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [GET_STOCK_ACTION_TYPE_OPTIONS](context) {
    return new Promise((resolve, reject) => {
      ApiService.query("stock/action-types/options")
        .then(({ data }) => resolve(data.data || data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [GET_STOCK_ACTION_STATUSES]() {
    return new Promise((resolve, reject) => {
      ApiService.get("stock/action-statuses")
        .then(({ data }) => resolve(data.data || data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [GET_STOCK_EXTRA_COST_TYPE_OPTIONS](context) {
    return new Promise((resolve, reject) => {
      ApiService.query("stock/extra-cost-types/options")
        .then(({ data }) => resolve(data.data || data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [GET_STOCK_EXTRA_COST_ALLOCATION_METHOD_OPTIONS](context) {
    return new Promise((resolve, reject) => {
      ApiService.query("stock/extra-cost-allocation-methods/options")
        .then(({ data }) => resolve(data.data || data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [UPLOAD_STOCK_RECEIPT_FILES](context, payload) {
    const formData = new FormData();
    (payload.files || []).forEach((file) => formData.append("files[]", file));

    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${payload.id}/files`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [DELETE_STOCK_RECEIPT_FILE](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.delete(`${PATH}/${payload.id}/files/${payload.fileId}`)
        .then(() => resolve(true))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [DOWNLOAD_STOCK_RECEIPT_FILE](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.downloadFile(
        `${PATH}/${payload.id}/files/${payload.fileId}/download`,
        payload.originalName || payload.name || "download"
      )
        .then(() => resolve(true))
        .catch((error) => reject(error?.response?.data || error));
    });
  },

  [REGENERATE_STOCK_RECEIPT_DOCUMENT](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${id}/regenerate-document`)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [IMPORT_STOCK_RECEIPT_TRANSPORT_COST](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${id}/import-transport-cost`)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },
};

export default {
  state: {},
  getters: {},
  actions,
  mutations: {},
};
